import axios from 'axios'

import { GET_MAP_STATES, STATES_FOR_SELECT, GET_STATES, MAP_LOADING, GET_MAP_STATE_CONTACTS } from './types'

export const getMapStates = (options) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await axios.get('/map-of-states', { params: { ...options } })
    dispatch({
      type: GET_MAP_STATES,
      payload: response.data,
    })
    if (response.status === 200) {
      return response.data
    }
  } finally {
    dispatch(setLoading(false))
  }
}

export const getStatesForSelect = () => async (dispatch) => {
  const response = await axios.get('/map-of-states/for-select')
  dispatch({
    type: STATES_FOR_SELECT,
    payload: response.data,
  })
}

export const getAllStates = (options) => async (dispatch) => {
  const response = await axios.get('/map-of-states/getAllStates', {
    params: { ...options },
  })
  dispatch({
    type: GET_STATES,
    payload: response.data,
  })
}

const setLoading = (isLoading) => (dispatch) => {
  dispatch({ type: MAP_LOADING, payload: isLoading })
}

export const getContacts = (options) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await axios.get('/map-of-states/contacts', { params: { ...options } })
    dispatch({ type: GET_MAP_STATE_CONTACTS, payload: response.data })
  } finally {
    dispatch(setLoading(false))
  }
}
